import { useEffect } from "react";
import { useHideAdsByCookie } from "./helpers/useSubCookie";

export const AdditionalScripts = () => {
  const { isHideAds } = useHideAdsByCookie();

  const removeAdsByGoogleScript = () => {
    const adsByGoogleScript = document.getElementById("adsbygoogle-script");
    if (adsByGoogleScript) {
      adsByGoogleScript.remove();
    }
  };

  useEffect(() => {
    if (navigator.userAgent !== "ReactSnap") {
      //inject google ads script to head
      const adsByGoogleScript = document.createElement("script");
      adsByGoogleScript.src =
        "//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
      adsByGoogleScript.async = true;

      document.head.appendChild(adsByGoogleScript);
    }
  }, []);

  useEffect(() => {
    console.log("!!!-isHideAds", isHideAds());
    if (navigator.userAgent !== "ReactSnap") {
      //inject adnimation script to head
      if (!isHideAds()) {
        const administrationScript = document.createElement("script");
        administrationScript.src = "https://adncdn.net/OextERChUg";
        administrationScript.async = true;
        administrationScript.id = "administration-script";
        document.head.appendChild(administrationScript);
      } else {
        removeAdsByGoogleScript();
      }
    }

    return () => {
      removeAdsByGoogleScript();
    };
  }, [isHideAds(), window.location.pathname]);

  return null;
};
